import React, { FC } from 'react';
import styled from '@emotion/styled';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'next-i18next';
import ConfirmModal from 'src/components/ConfirmModal';
import { MobileModalType, ModalHeader, ModalHeaderTitle as ModalHeaderTitleBase } from 'src/components/ModalLayout';
import { productToPurchaseAtom } from 'src/stores/payments/atoms';
import getDeviceInfo from 'src/utils/device/info';
const CloseButton = styled.button`
  background-color: transparent;
  justify-content: center;
  align-items: center;
  display: flex;
  height: 40px;
  width: 40px;

  cursor: pointer;
  flex-shrink: 0;
  margin: -8px; // 버튼 클릭 용이를 위한 extra space만큼 negative margin 부여
`;
const ButtonIcon = styled.img`
  ${({
  theme
}) => theme.isRtl && `
    transform: scale(-1);
  `}
`;
const PaymentHeader = styled(ModalHeader)<{
  isMobileDevice: boolean;
}>`
  width: 100%;
  max-width: 650px;
  background-color: ${({
  theme
}) => theme.color.surface2};

  flex-direction: row;

  gap: 8px;
  padding-top: 20px;

  ${({
  isMobileDevice
}) => isMobileDevice && `
      // 모바일 기기에서는 버튼과 텍스트 위치 반대로 렌더링
      // 현 breakpoint 기준 데스크탑에서 열리는 팝업도 모바일 분기에 걸려서 기기 종료 기준으로 분기하기로 디자이너와 합의
      flex-direction: row-reverse;
  `}
`;
const ModalHeaderTitle = styled(ModalHeaderTitleBase)`
  ${({
  theme
}) => theme.screenSize.mobile} {
    margin: 0;
  }
`;
const PaymentHeaderTitle = styled(ModalHeaderTitle)`
  flex-grow: 1;
  ${({
  theme
}) => theme.screenSize.mobile} {
    margin: 0;
  }
`;
interface PaymentsHeaderProps {
  showCloseButton?: boolean;
  title?: string;
  isPaymentComplete?: boolean;
}
const PaymentsHeader: FC<PaymentsHeaderProps> = ({
  showCloseButton = true,
  title,
  isPaymentComplete = false
}) => {
  const [isCancelModalOpen, setIsCancelModalOpen] = React.useState(false);
  const product = useAtomValue(productToPurchaseAtom);
  const {
    t
  } = useTranslation();
  const {
    isMobile
  } = getDeviceInfo();
  const handleClickClose = () => {
    if (product && !isPaymentComplete) {
      setIsCancelModalOpen(true);
      return;
    }
    window.close();
  };
  const handleCloseModal = () => {
    setIsCancelModalOpen(false);
  };
  const handleConfirmCancel = () => {
    setIsCancelModalOpen(false);
    window.close();
  };
  return <>
      <PaymentHeader isMobileDevice={!!isMobile} data-sentry-element="PaymentHeader" data-sentry-source-file="Header.tsx">
        {title && <PaymentHeaderTitle mobileType={MobileModalType.SCREEN_MODAL}>
            {t(title)}
          </PaymentHeaderTitle>}
        {showCloseButton && <CloseButton data-testid='Payments-Header-close' onClick={handleClickClose}>
            <ButtonIcon src='/images/icons/icCloseGray.svg' alt='close' />
          </CloseButton>}
      </PaymentHeader>
      {isCancelModalOpen && <ConfirmModal onCancel={handleCloseModal} onConfirm={handleConfirmCancel} />}
    </>;
};
export default PaymentsHeader;